const globalStyleIdCP = 'gs-text-main-compare-price';
const globalStyleId = 'gs-text-main-2';
// Do Setting Group Của Template cũ lấy name là Price
// Support Template "Urgence Backpacks"
const globalStyleIdClone = globalStyleId;
const globalStyleIdPercentageSaved = 'gs-text-main-percentage-saved';
const defaultSelectorComparePrice = {
  selector: '#{mID} .gf_product-compare-price',
};
const defaultSelector = {
  selector: '#{mID} .gf_product-price',
};
const defaultSelectorPercentageSaved = {
  selector: '#{mID} .gf_pq-discount',
};
export default {
  defaultClass: 'gf_gs-text-paragraph-1',
  settingGroups: {
    [globalStyleIdCP]: {
      'compare-size': {
        ...defaultSelectorComparePrice,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      // "compare-color": {
      //   ...defaultSelectorComparePrice,
      //   inherit: "text.fontColor",
      //   cssAttr: "color",
      // },
      'price-margin': {
        ...defaultSelectorComparePrice,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      'compare-style': {
        ...defaultSelectorComparePrice,
        inherit: 'text.fontStyle',
        cssAttr: 'font-style',
      },
      'compare-font-weight': {
        ...defaultSelectorComparePrice,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'compare-font': {
        ...defaultSelectorComparePrice,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
    },
    [globalStyleId]: {
      fontWeight: {
        ...defaultSelector,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-size': {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      // color: {
      //   ...defaultSelector,
      //   inherit: "text.fontColor",
      //   cssAttr: "color",
      // },
      'font-style': {
        ...defaultSelector,
        inherit: 'text.fontStyle',
        cssAttr: 'font-style',
      },
      'font-style-weight': {
        ...defaultSelector,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-style-decoration': {
        ...defaultSelector,
        inherit: 'text.decoration',
        cssAttr: 'text-decoration',
      },
      font: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
    },
    [globalStyleIdClone]: {
      fontWeight: {
        ...defaultSelector,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-size': {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      // color: {
      //   ...defaultSelector,
      //   inherit: "text.fontColor",
      //   cssAttr: "color",
      // },
      'font-style': {
        ...defaultSelector,
        inherit: 'text.fontStyle',
        cssAttr: 'font-style',
      },
      'font-style-weight': {
        ...defaultSelector,
        inherit: 'text.fontWeight',
        cssAttr: 'font-weight',
      },
      'font-style-decoration': {
        ...defaultSelector,
        inherit: 'text.decoration',
        cssAttr: 'text-decoration',
      },
      font: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
    },
    [globalStyleIdPercentageSaved]: {
      'percent-discount-size': {
        ...defaultSelectorPercentageSaved,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      // "percent-discount-color": {
      //   ...defaultSelectorPercentageSaved,
      //   inherit: "text.fontColor",
      //   cssAttr: "color",
      // },
      'percent-discount-font': {
        ...defaultSelectorPercentageSaved,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
      'percent-discount-style': {
        ...defaultSelectorPercentageSaved,
        inherit: 'text.fontStyle',
        cssAttr: 'font-style',
      },
    },
  },
};

export const P_PRICE_SETTING = [
  {
    gsId: globalStyleIdCP,
    gsSettingGroup: 'Compare Price',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading-paragraph',
    isSettingAdvand: true,
  },
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Style',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading-paragraph',
  },
  {
    gsId: globalStyleIdClone,
    gsSettingGroup: 'Price',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading-paragraph',
  },
  {
    gsId: globalStyleIdPercentageSaved,
    gsSettingGroup: 'Percentage Saved',
    isRenderColumn: false,
    prefix: 'gf_gs-text-',
    typeSetting: 'heading-paragraph',
    isSettingAdvand: true,
  },
];
